import React from 'react'
import _ from 'lodash'

import './style.css'

class StickyFooter extends React.PureComponent {
  constructor() {
    super()

    this.state = {
      scrolledToBottom: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', _.throttle(() => {
      this.fireOnScrollHandlers()
      this.setState({ scrolledToBottom: this.isUserScrolledToBottom() })
    }, 200))

    this.setState({
      scrolledToBottom: this.isUserScrolledToBottom()
    })
  }
  
  isUserScrolledToBottom() {
    return (window.innerHeight + Math.ceil(window.pageYOffset + 1)) >= document.body.scrollHeight
  }

  componentDidUpdate() {
    if (this.state.scrolledToBottom) 
      this.fireOnBottomHandlers()
  }

  fireOnBottomHandlers() {
    const onBottomHandlers = this.props.onBottom
    
    if (!onBottomHandlers)
      return

    if (typeof onBottomHandlers === 'function') {
      onBottomHandlers()
      return
    }

    if (Array.isArray(onBottomHandlers)) {
      _.each(onBottomHandlers, fn => fn())
      return
    }
  }

  fireOnScrollHandlers() {
    const onScrollHandlers = this.props.onScroll
    if (!onScrollHandlers)
      return

    if (typeof onScrollHandlers === 'function') {
      onScrollHandlers()
      return
    }

    if (Array.isArray(onScrollHandlers)) {
      _.each(onScrollHandlers, fn => fn())
      return
    }
  }

  get classNames() {
    let classNames = 'sticky-footer'
    classNames += this.state.scrolledToBottom ? ' floor' : ' sticky'

    if (this.props.className)
      classNames += ` ${this.props.className}`

    return classNames
  }

  render() {
    return(
      <div className={ this.classNames }>
        { this.props.children }
      </div>
    )
  }
}

export default StickyFooter
